import { FormControl, FormLabel, Grid, RadioGroup, Stack } from '@mui/material'
import { EFTypography } from '../EFTypography'
import { EFRadiosProps } from './EFRadio.model'

export default function EFRadioGroupBasic({
  children,
  alignLabel = 'left',
  isHorizontal,
  label,
  labelWidth,
  ...props
}: EFRadiosProps) {
  if (!isHorizontal)
    return (
      <FormControl>
        {label && (
          <FormLabel id='customized-radios'>
            <EFTypography>{label}</EFTypography>
          </FormLabel>
        )}

        <RadioGroup
          {...props}
          aria-labelledby='customized-radios'
        >
          {children}
        </RadioGroup>
      </FormControl>
    )
  return (
    <Grid
      container
      spacing={2}
      paddingY={1.5}
    >
      <Grid
        item
        xs={labelWidth}
        textAlign={alignLabel}
        pt='0.5rem !important'
        paddingRight={3}
      >
        <EFTypography fontSize='1rem'>{label}</EFTypography>
      </Grid>
      <Grid
        item
        pt='0rem !important'
      >
        <RadioGroup
          {...props}
          aria-labelledby='customized-radios'
        >
          <Stack direction='row'>{children}</Stack>
        </RadioGroup>
      </Grid>
    </Grid>
  )
}
